import { getStoryblokApi } from '@storyblok/react'
import { isNotFoundError } from '~/features/pages/isNotFoundError'
import { ExhibitorStory } from './types'

export async function fetchExhibitor(slug: string, preview?: boolean): Promise<ExhibitorStory | null> {
  const storyblok = getStoryblokApi()

  try {
    const { data } = await storyblok.get(`cdn/stories/aussteller/${slug}`, {
      version: preview ? 'draft' : 'published',
      resolve_links: 'story',
      resolve_relations: ['ExhibitorsBlock.exhibitors'],
      cv: Date.now(),
    })

    return data.story
  } catch (error) {
    // Depublizierte oder geloeschte Aussteller sollen 404 liefern, nicht 500.
    if (isNotFoundError(error)) {
      return null
    }

    console.error(`Failed to fetch exhibitor "${slug}" from Storyblok:`, error)
    throw error
  }
}
